import React from 'react';
import {Stack, Typography, useTheme} from '@mui/material';

import Icon from 'presentation/icons';
import {ProfileMenuItemProps} from '../ProfileMenu/types';
import {IconWithStatus} from '../ProfileMenu/IconWithStatus';
import {ProfileMenuItemStatus} from '../ProfileMenu/constants';

export function ProfileMenuItem({
	label,
	description,
	errorMessage,
	onClick,
	iconName,
	status = ProfileMenuItemStatus.DEFAULT,
	dataTestId,
	dataTagId,
	showErrorIcon,
}: ProfileMenuItemProps) {
	const theme = useTheme();
	const isError = status === ProfileMenuItemStatus.ERROR;

	return (
		<Stack
			onClick={onClick ? () => onClick() : undefined}
			data-testid={dataTestId}
			data-tag-id={dataTagId}
			sx={{
				gap: 1,
				cursor: 'pointer',
			}}>
			<Stack direction="row" alignItems="center" justifyContent="space-between">
				<Stack direction="row" alignItems="center" gap={2} width="fit-content">
					<IconWithStatus iconName={iconName} status={status} />

					<Stack>
						<Typography variant="body1" fontWeight={600} color="text.primary">
							{label}
						</Typography>

						{isError ? (
							<Typography variant="body2" color={'error.main'}>
								{errorMessage}
							</Typography>
						) : (
							<Typography
								variant="body2"
								color={'text.secondary'}
								sx={{
									overflowWrap: 'anywhere',
								}}>
								{description}
							</Typography>
						)}
					</Stack>
				</Stack>

				<Stack flexDirection="row" alignItems="center" gap={0.5}>
					{showErrorIcon ? (
						<Icon color={theme.palette.error.main} name="error-fill" size={16} />
					) : null}
					<Icon
						name="chevron-right-outlined"
						size={20}
						color={theme.palette.primary.main}
					/>
				</Stack>
			</Stack>
		</Stack>
	);
}
